/* eslint-disable import/no-unresolved */
import React from 'react';

import mobileSVG from 'assets/resources/icon/mobile.svg';
import cheapeSVG from 'assets/resources/icon/cheap.svg';
import performanceSVG from 'assets/resources/icon/performance.svg';
import securitySVG from 'assets/resources/icon/security.svg';
import ImgHTML from '../../../ImgHTML';

const AwardedIcons = () => {
  return (
    <div className="icon-beam">
      <div className="subtitle-simple">Your app can be</div>
      <div className="row">
        <div className="col-md-6">
          <div className="single-item">
            <div className="icon ed">
              <img
                src={mobileSVG}
                className="img-fluid"
                alt="mobile"
                title="Mobile"
              />
            </div>
            <div className="content">
              <div className="tt">Mobile</div>
              <div className="dd">
                <p>
                  Fast and efficient when you need to do a release, add new
                  features and fix bugs.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="single-item">
            <div className="icon">
              <ImgHTML src={cheapeSVG} alt="cheape icon" />
            </div>
            <div className="content">
              <div className="tt">Cost effective</div>
              <div className="dd">
                <p>
                  Maintenance of reliable and modern apps is much cheaper than
                  outdated and buggy apps.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="single-item">
            <div className="icon">
              <ImgHTML src={performanceSVG} alt="performance icon" />
            </div>
            <div className="content">
              <div className="tt">Fast</div>
              <div className="dd">
                <p>
                  Customers need systems that run smoothly without
                  interruptions.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="single-item">
            <div className="icon">
              <ImgHTML src={securitySVG} alt="security icon" />
            </div>
            <div className="content">
              <div className="tt">Reliable</div>
              <div className="dd">
                <p>
                  Users of your system will not be patient. Give them a product
                  that will satisfy their needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AwardedIcons;
